export default function({ state, commit, dispatch }, watch) {
	const message = {
		action: '$default',
		subscribe: (Array.isArray(watch)) ? watch : [ watch ]
	}

	if (state.socket) {
		state.socket.send(JSON.stringify(message))
	}
	else {
		state.queue.push(message)
	}
}
